import { useCallback, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  isFetchingCategories,
  getFetchCategoriesFailure,
  isSuccessFetchCategories,
  actions,
  getCategories
} from "../modules/market";

export default function useFetchCategories({ dealerId }) {
  const loading = useSelector(isFetchingCategories);
  const failure = useSelector(getFetchCategoriesFailure);
  const success = useSelector(isSuccessFetchCategories);
  const categories = useSelector(getCategories);

  const dispatch = useDispatch();

  const fetchCategories = useCallback(
    ({ dealerId, query }) => {
      dispatch(actions.fetchCategories({ dealer_id: dealerId, query }));
    },
    [dispatch]
  );

  useEffect(() => {
    if (dealerId) {
      fetchCategories({
        dealerId,
        query: ""
      });
    }
  }, [dealerId, fetchCategories]);

  return {
    loading: loading,
    failure: failure,
    success: success,
    categories,
    fetchCategories
  };
}
